module.exports = __webpack_public_path__ + "static/media/IMG_7667.58bda9e4.jpg";